import React, { useState, ReactNode } from "react";
import { Icon } from "../icons/icon";
import cn from "classnames";
import styles from "./collapsible-content.module.scss";

type viewType = "plus" | "arrow"

interface CollapsibleContentProps {
    viewType?: viewType;
    id?: string;
    onChangeState?: (id: string, state: boolean) => void;
    title: string | ReactNode;
    children: ReactNode;
    childClassName?: string;
    defaultOpen?: boolean;
    showDivider?: boolean;
}

export const CollapsibleContent: React.FC<CollapsibleContentProps> = ({
                                                                          childClassName,
                                                                          viewType = "plus",
                                                                          onChangeState,
                                                                          id,
                                                                          title,
                                                                          children,
                                                                          defaultOpen = false,
                                                                          showDivider = true,
                                                                      }) => {
    const [isOpen, setIsOpen] = useState<boolean>(defaultOpen);

    const toggleContent = (): void => {
        setIsOpen((prev) => {
            if (onChangeState && id) {
                onChangeState(id, !prev);
            }
            return !prev;
        });

    };

    return (
        <div className={styles.collapsibleContent}>
            {viewType === "plus" && <div className={styles.headerPlus} onClick={toggleContent}>
                <button className={styles.toggleBtn}>
                    {isOpen ? "−" : "+"}
                </button>
                <div>{title}</div>
            </div>}
            {viewType === "arrow" && <div className={styles.headerArrow} onClick={toggleContent}>
                <div>{title}</div>
                <div className={styles.arrowIcon}>
                    {isOpen ? <Icon glyph="arrowShortUp"/> : <Icon glyph="arrowShortDown"/>}
                </div>
            </div>}
            {isOpen && <div className={cn(styles.content, childClassName)}>{children}</div>}
            {viewType === "arrow" && showDivider && <div className={styles.divider}/>}
        </div>
    );
};
